"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _polished = require("polished");

var _reactIntl = require("react-intl");

var _Box = _interopRequireDefault(require("@match/react-component-library/components/Box"));

var _constants = require("@match/react-component-library/components/theme/constants");

var _theming = _interopRequireDefault(require("../../utils/theming"));

var _messages = require("../../constants/messages");

var _routes = require("../../constants/routes");

var _syntheticButton = _interopRequireDefault(require("../synthetic-button"));

// TODO this was a fluxible base link
var StyledLink = (0, _theming.default)('a')(function (_ref) {
  var _ref2;

  var theme = _ref.theme;
  return _ref2 = {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none'
  }, (0, _defineProperty2.default)(_ref2, ':focus', {
    background: "".concat((0, _polished.transparentize)(0.8, theme.palette.dark))
  }), (0, _defineProperty2.default)(_ref2, ':focus-visible', {
    background: (0, _polished.transparentize)(0.9, theme.palette.core1_100),
    boxShadow: "0 0 10px 3px ".concat((0, _polished.transparentize)(0.95, theme.palette.dark))
  }), (0, _defineProperty2.default)(_ref2, ':hover', {
    background: "".concat((0, _polished.transparentize)(0.9, theme.palette.dark)),
    textDecoration: 'none'
  }), _ref2;
});

var PowerUpButton = function PowerUpButton(_ref3) {
  var canReactivate = _ref3.canReactivate,
      isNeedingValidIdCertifcate = _ref3.isNeedingValidIdCertifcate,
      isSubscriber = _ref3.isSubscriber,
      _ref3$shouldShowPower = _ref3.shouldShowPowerUpButton,
      shouldShowPowerUpButton = _ref3$shouldShowPower === void 0 ? true : _ref3$shouldShowPower;

  if (!shouldShowPowerUpButton) {
    return _react.default.createElement(_Box.default, {
      width: 90
    });
  }

  var messageId;
  var href;

  if (canReactivate) {
    messageId = _messages.MESSAGE_ID.POWER_BTN_REACTIVATE;
    href = _routes.ROUTE.REACTIVATE;
  } else if (isSubscriber) {
    messageId = _messages.MESSAGE_ID.POWER_BTN_POWER_UP;
    href = _routes.ROUTE.SUBSCRIBE_POWER_UP;
  } else if (isNeedingValidIdCertifcate) {
    messageId = _messages.MESSAGE_ID.POWER_BTN_SUBSCRIBE;
    href = _routes.ROUTE.PROFILE_EDIT_CERTIFICATES;
  } else {
    messageId = _messages.MESSAGE_ID.POWER_BTN_SUBSCRIBE;
    href = _routes.ROUTE.SUBSCRIBE;
  }

  return _react.default.createElement(StyledLink, {
    href: href
  }, _react.default.createElement(_syntheticButton.default, {
    inverse: true,
    size: "small",
    color: _constants.SEMANTIC_COLOR_NAME.CTA_PRIMARY
  }, _react.default.createElement(_reactIntl.FormattedMessage, {
    id: messageId
  })));
};

var _default = PowerUpButton;
exports.default = _default;